import { render, staticRenderFns } from "./selectionCard.vue?vue&type=template&id=d2f9af70&scoped=true"
import script from "./selectionCard.vue?vue&type=script&lang=js"
export * from "./selectionCard.vue?vue&type=script&lang=js"
import style0 from "./selectionCard.vue?vue&type=style&index=0&id=d2f9af70&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2f9af70",
  null
  
)

export default component.exports